export const REQUEST_STATE = 'REQUEST_STATE'
export const SET_ERROR = 'SET_ERROR'
export const SET_LOADING = 'SET_LOADING'

export const LOGOUT = 'LOGOUT'
export const CORE_GET_USERS_REQUEST = 'CORE_GET_USERS_REQUEST'
export const CORE_GET_USERS_SUCCESS = 'CORE_GET_USERS_SUCCESS'
export const CORE_GET_USERS_FAILURE = 'CORE_GET_USERS_FAILURE'

export const CORE_GET_USER_INFO_REQUEST = 'CORE_GET_USER_INFO_REQUEST'
export const CORE_GET_USER_INFO_SUCCESS = 'CORE_GET_USER_INFO_SUCCESS'
export const CORE_GET_USER_INFO_FAILURE = 'CORE_GET_USER_INFO_FAILURE'

export const CORE_CHANGE_USER_NPI_PERMIT_REQUEST = 'CORE_CHANGE_USER_NPI_PERMIT_REQUEST'
export const CORE_CHANGE_USER_NPI_PERMIT_SUCCESS = 'CORE_CHANGE_USER_NPI_PERMIT_SUCCESS'
export const CORE_CHANGE_USER_NPI_PERMIT_FAILURE = 'CORE_CHANGE_USER_NPI_PERMIT_FAILURE'

export const CORE_CHANGE_USER_ADMIN_PERMIT_REQUEST = 'CORE_CHANGE_USER_ADMIN_PERMIT_REQUEST'
export const CORE_CHANGE_USER_ADMIN_PERMIT_SUCCESS = 'CORE_CHANGE_USER_ADMIN_PERMIT_SUCCESS'
export const CORE_CHANGE_USER_ADMIN_PERMIT_FAILURE = 'CORE_CHANGE_USER_ADMIN_PERMIT_FAILURE'

//AUTH
export const CORE_AUTH_VERIFY_REQUEST = 'CORE_AUTH_VERIFY_REQUEST'
export const CORE_AUTH_VERIFY_SUCCESS = 'CORE_AUTH_VERIFY_SUCCESS'
export const CORE_AUTH_VERIFY_FAILURE = 'CORE_AUTH_VERIFY_FAILURE'

export const CORE_GET_REQUEST_INFO_REQUEST = "CORE_GET_REQUEST_INFO_REQUEST"
export const CORE_GET_REQUEST_INFO_SUCCESS = "CORE_GET_REQUEST_INFO_SUCCESS"
export const CORE_GET_REQUEST_INFO_FAILURE = "CORE_GET_REQUEST_INFO_FAILURE"


//QR Tag
export const CORE_GET_RM_TAG_REQUEST = "CORE_GET_RM_TAG_REQUEST"
export const CORE_GET_RM_TAG_SUCCESS = "CORE_GET_RM_TAG_SUCCESS"
export const CORE_GET_RM_TAG_FAILURE = "CORE_GET_RM_TAG_FAILURE"

export const CORE_CREATE_RM_TAG_REQUEST = "CORE_CREATE_RM_TAG_REQUEST"
export const CORE_CREATE_RM_TAG_SUCCESS = "CORE_CREATE_RM_TAG_SUCCESS"
export const CORE_CREATE_RM_TAG_FAILURE = "CORE_CREATE_RM_TAG_FAILURE"

export const CORE_GET_PD_TAG_REQUEST = "CORE_GET_PD_TAG_REQUEST"
export const CORE_GET_PD_TAG_SUCCESS = "CORE_GET_PD_TAG_SUCCESS"
export const CORE_GET_PD_TAG_FAILURE = "CORE_GET_PD_TAG_FAILURE"

export const CORE_CREATE_PD_TAG_REQUEST = "CORE_CREATE_PD_TAG_REQUEST"
export const CORE_CREATE_PD_TAG_SUCCESS = "CORE_CREATE_PD_TAG_SUCCESS"
export const CORE_CREATE_PD_TAG_FAILURE = "CORE_CREATE_PD_TAG_FAILURE"


//GET RESOURCES
export const CORE_LOAD_RESOURCES_REQUEST = "CORE_LOAD_RESOURCES_REQUEST"
export const CORE_LOAD_RESOURCES_SUCCESS = "CORE_LOAD_RESOURCES_SUCCESS"
export const CORE_LOAD_RESOURCES_FAILURE = "CORE_LOAD_RESOURCES_FAILURE"

//GET WAREHOUSES
export const CORE_LOAD_WAREHOUSES_REQUEST = "CORE_LOAD_WAREHOUSES_REQUEST"
export const CORE_LOAD_WAREHOUSES_SUCCESS = "CORE_LOAD_WAREHOUSES_SUCCESS"
export const CORE_LOAD_WAREHOUSES_FAILURE = "CORE_LOAD_WAREHOUSES_FAILURE"

//GET SCRAPT

export const CORE_LOAD_SCRAPS_REQUEST = "CORE_LOAD_SCRAPS_REQUEST"
export const CORE_LOAD_SCRAPS_SUCCESS = "CORE_LOAD_SCRAPS_SUCCESS"
export const CORE_LOAD_SCRAPS_FAILURE = "CORE_LOAD_SCRAPS_FAILURE"


export const CORE_CREATE_REGISTER_DAPLAYS_REQUEST = "CORE_CREATE_REGISTER_DAPLAYS_REQUEST"
export const CORE_CREATE_REGISTER_DAPLAYS_SUCCESS = "CORE_CREATE_REGISTER_DAPLAYS_SUCCESS"
export const CORE_CREATE_REGISTER_DAPLAYS_FAILURE = "CORE_CREATE_REGISTER_DAPLAYS_FAILURE"

export const CORE_ACTIVE_DISPLAYS_REQUEST = "CORE_ACTIVE_DISPLAYS_REQUEST"
export const CORE_ACTIVE_DISPLAYS_SUCCESS = "CORE_ACTIVE_DISPLAYS_SUCCESS"
export const CORE_ACTIVE_DISPLAYS_FAILURE = "CORE_ACTIVE_DISPLAYS_FAILURE"

export const CORE_GET_ALL_TABLE_REQUEST = "CORE_GET_ALL_TABLE_REQUEST"
export const CORE_GET_ALL_TABLE_SUCCESS = "CORE_GET_ALL_TABLE_SUCCESS"
export const CORE_GET_ALL_TABLE_FAILURE = "CORE_GET_ALL_TABLE_FAILURE"

export const CORE_GET_TABLE_BY_ID_REQUEST = "CORE_GET_TABLE_BY_ID_REQUEST"
export const CORE_GET_TABLE_BY_ID_SUCCESS = "CORE_GET_TABLE_BY_ID_SUCCESS"
export const CORE_GET_TABLE_BY_ID_FAILURE = "CORE_GET_TABLE_BY_ID_FAILURE"

export const CORE_MANAGER_VERIFY_REQUEST = "CORE_MANAGER_VERIFY_REQUEST"
export const CORE_MANAGER_VERIFY_SUCCESS = "CORE_MANAGER_VERIFY_SUCCESS"
export const CORE_MANAGER_VERIFY_FAILURE = "CORE_MANAGER_VERIFY_FAILURE"

export const CORE_GET_PDS_FROM_AX_REQUEST = "CORE_GET_PDS_FROM_AX_REQUEST"
export const CORE_GET_PDS_FROM_AX_SUCCESS = "CORE_GET_PDS_FROM_AX_SUCCESS"
export const CORE_GET_PDS_FROM_AX_FAILURE = "CORE_GET_PDS_FROM_AX_FAILURE"

export const CORE_SET_WORKER_REQUEST = "CORE_SET_WORKER_REQUEST"
export const CORE_SET_WORKER_SUCCESS = "CORE_SET_WORKER_SUCCESS"
export const CORE_SET_WORKER_FAILURE = "CORE_SET_WORKER_FAILURE"

export const CORE_SET_START_TIME_REQUEST = "CORE_SET_START_TIME_REQUEST"
export const CORE_SET_START_TIME_SUCCESS = "CORE_SET_START_TIME_SUCCESS"
export const CORE_SET_START_TIME_FAILURE = "CORE_SET_START_TIME_FAILURE"

export const CORE_SET_END_TIME_REQUEST = "CORE_SET_END_TIME_REQUEST"
export const CORE_SET_END_TIME_SUCCESS = "CORE_SET_END_TIME_SUCCESS"
export const CORE_SET_END_TIME_FAILURE = "CORE_SET_END_TIME_FAILURE"


export const CORE_TASK_ON_JOB_REQUEST = "CORE_TASK_ON_JOB_REQUEST"
export const CORE_TASK_ON_JOB_SUCCESS = "CORE_TASK_ON_JOB_SUCCESS"
export const CORE_TASK_ON_JOB_FAILURE = "CORE_TASK_ON_JOB_FAILURE"

export const CORE_REPORT_AS_FINISHED_DATAS_REQUEST = "CORE_REPORT_AS_FINISHED_DATAS_REQUEST"
export const CORE_REPORT_AS_FINISHED_DATAS_SUCCESS = "CORE_REPORT_AS_FINISHED_DATAS_SUCCESS"
export const CORE_REPORT_AS_FINISHED_DATAS_FAILURE = "CORE_REPORT_AS_FINISHED_DATAS_FAILURE"

export const CORE_LOAD_MATERIALS_BY_WAREHOUSE_ID_REQUEST = "CORE_LOAD_MATERIALS_BY_WAREHOUSE_ID_REQUEST"
export const CORE_LOAD_MATERIALS_BY_WAREHOUSE_ID_SUCCESS = "CORE_LOAD_MATERIALS_BY_WAREHOUSE_ID_SUCCESS"
export const CORE_LOAD_MATERIALS_BY_WAREHOUSE_ID_FAILURE = "CORE_LOAD_MATERIALS_BY_WAREHOUSE_ID_FAILURE"


// WEBPACK FOOTER //
// ./src/app/redux/types.js